import { alias, custom, list, object, serializable } from 'serializr';

export class Children {
  @serializable
  id?: number;

  @serializable(
    custom(
      value => value ?? null,
      value => (typeof value === 'string' ? value : null)
    )
  )
  index?: string;

  @serializable
  name?: string;

  @serializable
  province?: string;

  @serializable
  country?: string;

  @serializable(alias('supplier_id'))
  supplierId?: number;

  @serializable(alias('temperature_control'))
  temperatureControl?: string;

  @serializable(alias('is_transported_by_air'))
  isTransportedByAir?: boolean;

  getFormattedAddress ?= (): string => [this.province, this.country].filter(Boolean).join(', ');
}

export class BaseItem extends Children {
  @serializable(list(object(Children)))
  children: Children[] = [];
}

export class TransportationDetails {
  @serializable(list(object(BaseItem)))
  fertilizers?: BaseItem[] = [];

  @serializable(list(object(BaseItem)))
  packagings?: BaseItem[] = [];
}

export class FlatBaseItem {
  @serializable
  id?: number;

  @serializable
  index?: string | null;

  @serializable
  name?: string | null;

  @serializable
  province?: string;

  @serializable
  country?: string;

  @serializable(alias('supplier_id'))
  supplierId?: number | null;

  @serializable(alias('temperature_control'))
  temperatureControl?: string | null;

  @serializable(alias('is_transported_by_air'))
  isTransportedByAir?: boolean | null;

  getFormattedAddress ?= (): string => [this.province, this.country].filter(Boolean).join(', ');
}

export class FlatTransportationDetails {
  @serializable(list(object(FlatBaseItem)))
  fertilizers?: FlatBaseItem[] = [];

  @serializable(list(object(FlatBaseItem)))
  packagings?: FlatBaseItem[] = [];
}
